import React, {useEffect} from 'react';
import {Layout, notification} from 'antd';
import {useUrlSearchParams} from 'use-url-search-params';
import './layout.style.less';
import {AppContentView} from '../../index';
import {LayoutType} from '../../../shared/constants/AppEnums';
import AppScrollbar from '../AppScrollbar';
import {
  useLayoutActionsContext,
  useLayoutContext,
} from '../../utility/AppContextProvider/LayoutContextProvider';
import {useSidebarActionsContext} from '../../utility/AppContextProvider/SidebarContextProvider';
import MiniSidebarToggle from './MiniSidebarToggle';
import {useSelector} from 'react-redux';
import {getIsAuthenticated} from 'src/domain/app/redux/auth/auth-selectors';
import Hotjar from '@hotjar/browser';
import {install} from 'inspectlet-es';
import {
  hotjarSiteId,
  hotjarVersion,
  inspectletId,
} from 'src/shared/constants/AppConst';
import {useInitSocketIo} from 'src/shared/hooks/socket-io';
import {getNewNotification} from 'src/domain/app/redux/notifications/notification-selectors';

const AppLayout = () => {
  const isAuthenticated = useSelector(getIsAuthenticated);
  const {layoutType}: any = useLayoutContext();
  const {updateNavStyle}: any = useLayoutActionsContext();
  const newNotification = useSelector(getNewNotification);
  const {updateMenuStyle, setSidebarBgImage}: any = useSidebarActionsContext();
  const [params] = useUrlSearchParams();

  useEffect(() => {
    Hotjar.init(hotjarSiteId, hotjarVersion);
  }, []);

  useEffect(() => {
    install(inspectletId);
  }, []);

  useInitSocketIo();

  useEffect(() => {
    if (layoutType === LayoutType.BOXED) {
      document.body.classList.add('boxedLayout');
      document.body.classList.remove('framedLayout');
    } else if (layoutType === LayoutType.FRAMED) {
      document.body.classList.remove('boxedLayout');
      document.body.classList.add('framedLayout');
    } else {
      document.body.classList.remove('boxedLayout');
      document.body.classList.remove('framedLayout');
    }
  }, [layoutType]);

  useEffect(() => {
    if (params.layout) updateNavStyle(params.layout);
    if (params.menuStyle) updateMenuStyle(params.menuStyle);
    if (params.sidebarImage) setSidebarBgImage(true);
  }, []);

  useEffect(() => {
    if (newNotification?.Title && newNotification?.Message) {
      notification.open({
        message: newNotification?.Title,
        description: newNotification?.Message,
      });
    }
  }, [newNotification]);

  return (
    <React.Fragment>
      {isAuthenticated ? (
        <MiniSidebarToggle />
      ) : (
        <Layout className='auth'>
          <AppScrollbar className='main-auth-scrollbar'>
            <AppContentView />
          </AppScrollbar>
        </Layout>
      )}
    </React.Fragment>
  );
};

export default React.memo(AppLayout);
